import { useCompassCard } from '@scale/compass-ui/store';
import type { SweapPassAtKContext } from '@scale/genai-compass-shared/cards/sweap_pass_at_k';
import type { ChatApiEndpointWithId } from '@scale/shared/types/chat';

export default function useSweapPassAtKCard(index: number) {
  const { card, updateCardContext } = useCompassCard<SweapPassAtKContext>(index);
  const context = card.defaultContext;

  const setK = (k: number) => {
    updateCardContext({ ...context, k });
  };

  const setConfigS3Uri = (configS3Uri: string) => {
    updateCardContext({ ...context, configS3Uri });
  };

  const setModelConfig = (modelConfig: ChatApiEndpointWithId | undefined) => {
    updateCardContext({ ...context, modelConfig } as SweapPassAtKContext);
  };

  return {
    context,
    setK,
    setConfigS3Uri,
    setModelConfig,
  };
}
